module.exports = __webpack_public_path__ + "static/img/jjc_second.375bd6e4.png";